import { render, staticRenderFns } from "./CompensationRefundTypesManager.vue?vue&type=template&id=05d7adb3"
import script from "./CompensationRefundTypesManager.vue?vue&type=script&lang=js"
export * from "./CompensationRefundTypesManager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports